import React, { useCallback } from 'react';
import {connect} from 'react-redux';
import {withRouter, Link} from 'react-router';
import {questionsForSection, nextQuestionForSection} from '../reducer';
import {Card, CardActions, CardTitle, CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import {getResponse} from '../reducer/response';
import {FormattedMessage, injectIntl} from "react-intl";

let content = {
  monitoring: {
    title: <FormattedMessage id="general.monitoring" defaultMessage="Data Collection" />,
    description: <FormattedMessage id="questionnaireIntro.monitoringDescription" defaultMessage="The following questions are designed to characterize your fishery so that options appropriate to your fishery can be identified and non-workable options can be flagged.  The first questions refer to minimum criteria for each monitoring method and help to subset all methods to those available to your fishery.  The next set of questions (caveat questions) help to identify the challenges and benefits of each monitoring method that are unique to the characteristics of your fishery.  If you are unsure of an answer provided, you may flag the question by clicking on the bookmark in the upper right hand corner of the screen.  When reviewing results, you will have the ability to review these flagged answers and adjust them as needed." />
  },
  assessment: {
    title: <FormattedMessage id="general.assessment" defaultMessage="Assessment" />,
    description: <FormattedMessage id="questionnaireIntro.assessmentDescription" defaultMessage="The following questions are designed to characterize your fishery so that options appropriate to your fishery can be identified and non-workable options can be flagged.  The first questions refer to minimum criteria for each assessment method and help to subset all methods to those available to your fishery.  The next set of questions (caveat questions) help to identify the challenges and benefits of each assessment method that are unique to the characteristics of your fishery.  If you are unsure of an answer provided, you may flag the question by clicking on the bookmark in the upper right hand corner of the screen.  When reviewing results, you will have the ability to review these flagged answers and adjust them as needed." />

  },
  controlRules: {
    title: <FormattedMessage id="general.controlRules" defaultMessage="Management Measures" />,
    description: <FormattedMessage id="questionnaireIntro.controlRulesDescription" defaultMessage="The following questions are designed to characterize your fishery so that options appropriate to your fishery can be identified and non-workable options can be flagged.  This set of questions (caveat questions) help to identify the challenges and benefits of each decision rule option that are unique to the characteristics of your fishery.  If you are unsure of an answer provided, you may flag the question by clicking on the bookmark in the upper right hand corner of the screen.  When reviewing results, you will have the ability to review these flagged answers and adjust them as needed." />
  },
  enforcement:{
    title: <FormattedMessage id="general.enforcement" defaultMessage="Enforcement" />,
    description: <FormattedMessage id="questionnaireIntro.enforcementDescription" defaultMessage="The following questions are designed to characterize your fishery so that options appropriate to your fishery can be identified and non-workable options can be flagged. The first questions refer to minimum criteria for each enforcement method and help to subset all methods to those available to your fishery. The next set of questions (caveat questions) help to identify the challenges and benefits of each enforcement method that are unique to the characteristics of your fishery. If you are unsure of an answer provided, you may flag the question by clicking on the bookmark in the upper right hand corner of the screen. When reviewing results, you will have the ability to review these flagged answers and adjust them as needed." />
  }
}

class SectionIntro extends React.Component {
  render() {
    const intl = this.props.intl
    const { title, description } = this.props.content;
    //let unansweredQuestions = this.props.questions.filter((q) => !this.props.answers[q.id]);
    let numQuestions = this.props.questions.length;
    let section = this.props.section;
    let firstQuestion = "/questionnaire/" + this.props.response.metadata.id + "/" + section + "/" + (this.props.nextQuestion ? this.props.nextQuestion.id : null);
    var skip = `/home/${this.props.response.metadata.id}`
    let trID = this.props.response.userEdits ? this.props.response.userEdits.trIDForResponse : -1

    return (
      <Card style={{maxWidth: 800, margin: '0 auto'}}>
        <CardTitle title={title} subtitle={intl.formatMessage({id:"questionnaireIntro.numQuestion", defaultMessage:"{numQuestions, number} Questions in this section"}, {numQuestions:numQuestions})} />
        <CardText>
          {description}
        </CardText>
        <CardActions style={{textAlign: "center", paddingRight: 50, paddingBottom: 20}}>
          <FlatButton
            onClick={() => this.props.router.push(skip)}
            label={intl.formatMessage({id:"questionnaireIntro.chooseSection", defaultMessage:"Choose another section"})}
          />
          <RaisedButton
            containerElement={<Link to={firstQuestion} />}
            label={intl.formatMessage({id:"general.next", defaultMessage:"Next"})}
            primary={true}
          />
        </CardActions>
      </Card>
    )
  }
}

let mapStateToProps = (state, ownProps) => {
  let section = ownProps.params.section;
  let response = getResponse(state);
  return {
    section,
    content: content[section],
    questions: questionsForSection(state),
    answers: response.answers,
    nextQuestion: nextQuestionForSection(section, response, state),
    response: response,
    translationList: state.translationList.filter(tr => tr.published)
  }
}


export default connect(mapStateToProps, null)(injectIntl(withRouter(SectionIntro)))
